module.exports = __webpack_public_path__ + "img/all-monitors.04cf25b6.svg";